import { useIntl } from 'react-intl'
import { connect, useDispatch, useSelector } from 'react-redux'
import SectionContainer from '@components/Layout/SectionContainer/SectionContainer'
import NewsType from './NewsType/NewsType'
import './NewActivityNews.scss'
import {
    ActivitySection,
    NewActivitySectionType,
    NewNewsStepNavigation,
} from '@/app/models/new-activity-section-type'
import {
    createProject,
    editProject,
    historyChange,
    NewActivityCreationActions,
    setActivitySectionStatus,
    setActivityTypeList,
    setCtaTemplate,
    setCurrentStep,
    setIsActivityTypeStep,
    setNewActivityForm,
    setResetMandatory,
    setSelectedActivityType,
    setSmartFilterActivity,
} from '@/app/redux/actions/activity-creation'
import NewsMainInfo from './NewsMainInfo/NewsMainInfo'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'
import Scheduling from '../Scheduling/Scheduling'
import Distribution from '../Distribution/DistributionList'
import {
    DistributionForm,
    FormField,
    NewsForm,
    NewsMainInfoForm,
    SubActivityTypeForm,
    SchedulingForm,
    PointsAssignmentForm,
} from '@/app/models/new-activity-form'
import { useEffect, useState } from 'react'
import { ActivityStep } from '@/app/models/new-activity-creation-state'
import { newsForm } from '@/app/models/new-activity-news-form'
import {
    Analytics,
    AppState,
    LayoutActivityType,
    SmartlyActionItems,
} from '@Techedge/digitalportal-shared'
import {
    getActivityApi,
    getDateDiff,
    getEditProject,
    getEditSelectedStoreList,
} from '@/app/utils/activityAdapter'
import { ProjectApiCreateActivityBody, ProjectApiStatus } from '@/app/models/projects-service'
import { creationCta, editCta } from '@/app/models/new-activity-creation-cta'
import DialogDuplicate from '../../UI/Dialogs/DialogDuplicate/DialogDuplicate'
import { CtaGroupWrapper } from '../../UI/CtaGroup/CtaGroupWrapper'
import { cancelProject, saveAsToBeReleased } from '@/app/redux/actions/activity-execution'
import EditingReason from '../EditingReason/EditingReason'
import DialogHistoryChange from '../../UI/Dialogs/DialogHistoryChange/DialogHistoryChange'
import DialogResetStore from '../../UI/Dialogs/DialogResetStore/DialogResetStore'
import { creationAnalyticsPageTypeMap } from '@/app/models/analyticsPageTypeMap'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@redux/reducers/activity-execution'
import { Color, LuxButton } from '@lux/wardrobe-lib'
import SectionBox from '../../Layout/SectionBox/SectionBox'
import { selectCurrentStep } from '@/app/redux/selector/activity-creation'
import { SectionFilter } from '@/app/models/search'
import { PointsAssignments } from '../PointsAssignment/PointsAssignments'

const NewActivityNews = (props) => {
    const {
        sectionMap,
        form,
        setActivitySectionStatus,
        setForm,
        projectVisibilityOptions,
        typeList,
        setActivityTypeList,
        setCtaTemplate,
        projectDetails,
        createProject,
        isClone,
        cancelProject,
        storeIdList,
        isEdit,
        historyChange,
        changeFields,
        editProject,
        isResetMandatory,
        setResetMandatory,
        saveAsToBeReleased,
        storesToImport,
        openDialogUploadList,
        openDialogExportTemplate,
        activityTypeList,
        storesList,
        smartFilter,
        setSmartFilter,
    } = props

    const intl = useIntl()
    const dispatch = useDispatch()
    const step = useSelector(selectCurrentStep)
    const hasSocialHubEnabled = useSelector(
        (state: AppState) => state.userReducer.user.phase3_enabled
    )

    const componentClass = 'smart-new-activity-news'

    const [showDuplicateDialog, setShowDuplicateDialog] = useState(false)
    const [showHistoryChangeDialog, setShowHistoryChangeDialog] = useState(false)

    const [reasonWhy, setReasonWhy] = useState('')
    const [editingReason, setEditingReason] = useState('')
    const [messageForStores, setMessageForStore] = useState('')

    const [editStatusAction, setEditStatusAction] = useState('')

    const ctaHandler = async (action: string, form) => {
        let newProjectDetails
        switch (action) {
            case NewActivityCreationActions.CREATE_AS_TO_BE_RELEASED:
                createProject(
                    getActivityApi(form, ProjectApiStatus.TO_BE_RELEASED, SmartlyActionItems.NEWS),
                    intl.formatMessage({
                        id: 'modals.activity.create.conclude.success.message',
                        defaultMessage: 'Project created successfully!',
                    })
                )
                break
            case NewActivityCreationActions.CREATE_AS_DRAFT:
                createProject(
                    getActivityApi(form, ProjectApiStatus.DRAFT, SmartlyActionItems.NEWS),
                    intl.formatMessage({
                        id: 'modals.activity.create.draft.success.message',
                        defaultMessage: 'Project saved as draft successfully!',
                    }),
                    intl.formatMessage({
                        id: 'modals.activity.create.draft.error.message',
                        defaultMessage:
                            'You need to complete all required fields across the entire flow before saving as draft.',
                    })
                )
                break
            case NewActivityCreationActions.SAVE_AS_TO_BE_RELEASED:
                saveAsToBeReleased(
                    projectDetails.id,
                    intl.formatMessage({
                        id: 'modals.activity.create.conclude.success.message',
                        defaultMessage: 'Project created successfully!',
                    }),
                    storeIdList
                )
                break
            case NewActivityCreationActions.CLONE:
                setShowDuplicateDialog(true)
                break
            case NewActivityCreationActions.CANCEL:
                cancelProject(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.approval.cancel.success.message',
                        defaultMessage: 'Store redo successfully!',
                    })
                )
                break
            case NewActivityCreationActions.HISTORY_CHANGE:
                newProjectDetails = getEditProject(form, projectDetails)
                historyChange({ ...newProjectDetails })
                Analytics._sendAnalyticsLinkEvent(
                    'Activities',
                    creationAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                        .history,
                    'Static'
                )
                setShowHistoryChangeDialog(true)
                break
            case NewActivityCreationActions.EDIT_RELEASE:
                setEditStatusAction('released')
                newProjectDetails = getEditProject(form, projectDetails)
                historyChange(
                    { ...newProjectDetails },
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    'released'
                )
                break
            case NewActivityCreationActions.EDIT_SAVE_AS_DRAFT:
                setEditStatusAction('draft')
                newProjectDetails = getEditProject(form, projectDetails)
                const statusAction = newProjectDetails.status !== 'draft' ? 'draft' : ''
                historyChange(
                    { ...newProjectDetails },
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    statusAction
                )
                break
            case NewActivityCreationActions.EDIT_SAVE_AS_TO_BE_RELEASED:
                setEditStatusAction('toBeReleased')
                newProjectDetails = getEditProject(form, projectDetails)
                historyChange(
                    { ...newProjectDetails },
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    'toBeReleased'
                )
                break
        }
    }

    const handlerEditProject = (confirm) => {
        if (!confirm) {
            setResetMandatory(false)
            return
        }

        let newForm = { ...form }

        const newProjectDetails = getEditProject(newForm, projectDetails)

        editProject(
            newProjectDetails,
            reasonWhy,
            editingReason,
            messageForStores,
            intl.formatMessage({
                id: 'modals.activity.create.edit.success.message',
                defaultMessage: 'Project edit successfully!',
            }),
            editStatusAction
        )
    }

    const onDuplicateConfirm = (confirm: boolean) => {
        if (confirm) {
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: false }
            )
            setForm(
                {
                    title: {
                        ...form[NewActivitySectionType.MAIN_INFO].title,
                        value: `${form[NewActivitySectionType.MAIN_INFO].title.value} - Copy`,
                    },
                },
                NewActivitySectionType.MAIN_INFO,
                ActivitySection.NEWS_ACTIVITY
            )
            setForm(
                {
                    startDate: {
                        ...form[NewActivitySectionType.SCHEDULING].startDate,
                        value: null,
                    },
                    endDate: {
                        ...form[NewActivitySectionType.SCHEDULING].endDate,
                        value: null,
                    },
                    specificDate: {
                        ...form[NewActivitySectionType.SCHEDULING].specificDate,
                        value: null,
                    },
                },
                NewActivitySectionType.SCHEDULING,
                ActivitySection.NEWS_ACTIVITY
            )
        }
        setShowDuplicateDialog(false)
    }

    const isFormValid = () => {
        const badgeDisabled =
            !hasSocialHubEnabled ||
            (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id)
        const badgePoints =
            form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.points ||
            Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value)
        return (
            !!form[NewActivitySectionType.MAIN_INFO].cover.value.src &&
            !!form[NewActivitySectionType.MAIN_INFO].title.value &&
            !!form[NewActivitySectionType.MAIN_INFO].department.value &&
            form[NewActivitySectionType.DISTRIBUTION].selectedStoreList.value.length > 0 &&
            (badgeDisabled ||
                (Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) > 0 &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) <=
                        badgePoints)) &&
            !!form[NewActivitySectionType.SCHEDULING].startDate.value &&
            !!form[NewActivitySectionType.SCHEDULING].endDate.value &&
            !!form[NewActivitySectionType.SCHEDULING].projectVisibility.value &&
            !!form[NewActivitySectionType.SCHEDULING].priority.value &&
            (projectDetails?.status === 'draft' ||
                projectDetails?.status === 'rejected' ||
                !isEdit ||
                (isEdit && reasonWhy && editingReason))
        )
    }

    const onSectionSave = (sectionKey: NewActivitySectionType) => {
        setActivitySectionStatus(ActivitySection.NEWS_ACTIVITY, sectionKey, { isDone: true })
    }

    const onNewsTypeChange = (form: Partial<SubActivityTypeForm>) => {
        setForm(form, NewActivitySectionType.NEWS_TYPE, ActivitySection.NEWS_ACTIVITY)
        let isDone
        if (!!form.type) isDone = true
        setActivitySectionStatus(ActivitySection.NEWS_ACTIVITY, NewActivitySectionType.NEWS_TYPE, {
            isDone,
        })
    }

    const onMainInfoChange = (partialForm: Partial<NewsMainInfoForm>) => {
        setForm(partialForm, NewActivitySectionType.MAIN_INFO, ActivitySection.NEWS_ACTIVITY)
    }
    const onPointsAssignment = (partialForm: Partial<PointsAssignmentForm>) => {
        setForm(
            partialForm,
            NewActivitySectionType.POINTS_ASSIGNMENT,
            ActivitySection.NEWS_ACTIVITY
        )
    }

    const onDistributionChange = (partialForm: Partial<DistributionForm>) => {
        setForm(partialForm, NewActivitySectionType.DISTRIBUTION, ActivitySection.NEWS_ACTIVITY)
        let isDone
        if (partialForm.selectedStoreList.value.length > 0) isDone = true
        setActivitySectionStatus(
            ActivitySection.NEWS_ACTIVITY,
            NewActivitySectionType.DISTRIBUTION,
            { isDone }
        )
    }

    const onSchedulingChange = (partialForm: Partial<SchedulingForm>) => {
        setForm(partialForm, NewActivitySectionType.SCHEDULING, ActivitySection.NEWS_ACTIVITY)
        let isDone
        if (
            partialForm.startDate.value &&
            partialForm.endDate.value &&
            partialForm.priority.value &&
            partialForm.projectVisibility.value &&
            (partialForm.projectVisibility.value !== projectVisibilityOptions[3].value ||
                (partialForm.projectVisibility.value === projectVisibilityOptions[3].value &&
                    partialForm.specificDate.value))
        )
            isDone = true
        setActivitySectionStatus(ActivitySection.NEWS_ACTIVITY, NewActivitySectionType.SCHEDULING, {
            isDone,
        })
    }

    const onNextStep = () => {
        if (
            step === NewActivitySectionType.DISTRIBUTION &&
            (!hasSocialHubEnabled ||
                (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id))
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.SCHEDULING))
            return
        }
        dispatch(setCurrentStep(NewNewsStepNavigation[step].next))
    }
    const onBackStep = () => {
        if (step === NewActivitySectionType.EDITING_REASON) {
            dispatch(setSelectedActivityType({ key: LayoutActivityType.NEWS }))
            dispatch(setIsActivityTypeStep(true))
            dispatch(setCurrentStep(NewActivitySectionType.ACTIVITY_TYPE))
            return
        }
        if (
            !NewNewsStepNavigation[step].back &&
            isEdit &&
            projectDetails?.status !== SectionFilter.draft &&
            projectDetails?.status !== SectionFilter.rejected
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.EDITING_REASON))
            return
        }
        if (
            step === NewActivitySectionType.SCHEDULING &&
            (!hasSocialHubEnabled ||
                (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id))
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.DISTRIBUTION))
            return
        }
        if (!NewNewsStepNavigation[step].back) {
            dispatch(setSelectedActivityType({ key: LayoutActivityType.NEWS }))
            dispatch(setIsActivityTypeStep(true))
            dispatch(setCurrentStep(NewActivitySectionType.ACTIVITY_TYPE))
            return
        }
        dispatch(setCurrentStep(NewNewsStepNavigation[step].back))
    }

    useEffect(() => {
        dispatch(
            setCurrentStep(
                isEdit &&
                    projectDetails?.status !== SectionFilter.draft &&
                    projectDetails?.status !== SectionFilter.rejected
                    ? NewActivitySectionType.EDITING_REASON
                    : NewActivitySectionType.NEWS_TYPE
            )
        )
    }, [])

    useEffect(() => {
        if (step !== NewActivitySectionType.SCHEDULING)
            setCtaTemplate(
                <div className={`${componentClass}__cta-step`}>
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'back',
                            defaultMessage: 'Back',
                        })}
                        variant="text"
                        color={Color.BLACK}
                        onClick={onBackStep}
                    />
                    <div className={`${componentClass}__cta-step-right`}>
                        <LuxButton
                            text={intl.formatMessage({
                                id: 'modals.new.activity.creation.cta.save.as.draft',
                                defaultMessage: 'Save as draft',
                            })}
                            variant="outlined"
                            onClick={() =>
                                ctaHandler(
                                    isEdit
                                        ? NewActivityCreationActions.EDIT_SAVE_AS_DRAFT
                                        : NewActivityCreationActions.CREATE_AS_DRAFT,
                                    form
                                )
                            }
                            disabled={!isFormValid()}
                        />
                        <LuxButton
                            text={intl.formatMessage({
                                id: 'next',
                                defaultMessage: 'Next',
                            })}
                            color={Color.BLACK}
                            onClick={onNextStep}
                            disabled={!sectionMap[step]?.isDone}
                        />
                    </div>
                </div>
            )
    }, [step, sectionMap, form])

    useEffect(() => {
        // PERMISSION CTA
        const ctaConfig = !isEdit
            ? creationCta(
                  SmartlyActionItems.NEWS,
                  projectDetails?._id && !isClone
                      ? projectDetails
                      : { type: form?.subType?.type?.value }
              ).setDisableConditions([
                  {
                      action: NewActivityCreationActions.CREATE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.SAVE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.SAVE_AS_DRAFT,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.CREATE_AS_DRAFT,
                      disableCondition: !isFormValid(),
                  },
              ])
            : editCta(
                  SmartlyActionItems.NEWS,
                  projectDetails?._id ? projectDetails : { type: form?.subType?.type?.value }
              ).setDisableConditions([
                  {
                      action: NewActivityCreationActions.EDIT_RELEASE,
                      disableCondition: !isFormValid(),
                  },
                  {
                      action: NewActivityCreationActions.EDIT_SAVE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
              ])

        const newForm = { ...form, smartFilter }

        if (step === NewActivitySectionType.SCHEDULING) {
            setCtaTemplate(
                <div className={`${componentClass}__cta-step`}>
                    <LuxButton
                        text="Back"
                        variant="text"
                        color={Color.BLACK}
                        onClick={onBackStep}
                    />
                    <div className="smart-modals-cta-group-wrapper">
                        <CtaGroupWrapper
                            ctaConfig={ctaConfig}
                            componentClass={componentClass}
                            ctaHandler={(action) => ctaHandler(action, newForm)}
                        />
                    </div>
                </div>
            )
        }
    }, [form, projectDetails, reasonWhy, editingReason, smartFilter])

    useEffect(() => {
        if (projectDetails && activityTypeList.length) {
            setForm(
                {
                    type: {
                        ...form[NewActivitySectionType.NEWS_TYPE].type,
                        value: projectDetails.type,
                        label: activityTypeList
                            .find((a) => a.key === SmartlyActionItems.NEWS)
                            ?.subTypes.find((t) => t.value === projectDetails.type)?.label,
                        oldValue: projectDetails.type,
                    },
                },
                NewActivitySectionType.NEWS_TYPE,
                ActivitySection.NEWS_ACTIVITY
            )
        }
    }, [activityTypeList, projectDetails])

    useEffect(() => {
        const disabled = false
        if (projectDetails) {
            setActivityTypeList(ActivitySection.NEWS_ACTIVITY, typeList)
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.EDITING_REASON,
                { isDone: projectDetails?.reasonChange?.value?.length > 0 }
            )
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.NEWS_TYPE,
                { isDone: isClone || isEdit }
            )
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.MAIN_INFO,
                { isDone: isClone || isEdit }
            )
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.DISTRIBUTION,
                { isDone: isClone || isEdit }
            )
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.POINTS_ASSIGNMENT,
                { isDone: (isClone || isEdit) && !!projectDetails.badge }
            )
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: isEdit, isDirty: isClone }
            )
            const tempTitle = isClone
                ? `${projectDetails.projectTitle} - Copy`
                : projectDetails.projectTitle
            const attachments = []
            if (!!projectDetails.attachments)
                projectDetails.attachments.forEach((attachment) => {
                    if (attachment)
                        attachments.push({
                            _id: attachment._id,
                            file: attachment,
                            url: !!attachment && attachment.url,
                        })
                })
            setForm(
                {
                    cover: {
                        ...form[NewActivitySectionType.MAIN_INFO].cover,
                        value: {
                            ...form[NewActivitySectionType.MAIN_INFO].cover.value,
                            src: projectDetails.cover?.url,
                            id: projectDetails.cover?._id,
                        },
                        disabled,
                    },
                    title: {
                        ...form[NewActivitySectionType.MAIN_INFO].title,
                        value: tempTitle,
                        disabled,
                    },
                    department: {
                        ...form[NewActivitySectionType.MAIN_INFO].department,
                        value: projectDetails.department,
                        disabled,
                    },
                    recipient: {
                        ...form[NewActivitySectionType.MAIN_INFO].recipient,
                        value: projectDetails.assignment[0],
                        disabled,
                    },
                    info: {
                        ...form[NewActivitySectionType.MAIN_INFO].info,
                        value: projectDetails.information,
                        disabled,
                    },
                    attachmentList: {
                        ...form[NewActivitySectionType.MAIN_INFO].attachmentList,
                        value: [...attachments],
                        disabled,
                    },
                    confirmRead: {
                        ...form[NewActivitySectionType.MAIN_INFO].confirmRead,
                        value: projectDetails.requiredConfirmReading,
                        disabled,
                    },
                    messagingEnabled: {
                        ...form[NewActivitySectionType.MAIN_INFO].messagingEnabled,
                        value: projectDetails.enableMessaging,
                        disabled,
                    },
                    commentReaction: {
                        ...form[NewActivitySectionType.MAIN_INFO].commentReaction,
                        value: projectDetails.enableCommentsAndReactions,
                        disabled,
                    },
                },
                NewActivitySectionType.MAIN_INFO,
                ActivitySection.NEWS_ACTIVITY
            )
            setForm(
                {
                    selectedStoreList: {
                        ...form[NewActivitySectionType.DISTRIBUTION].selectedStoreList,
                        value: storesList.map((s) => ({
                            ...s,
                            store_id: s.storeId,
                        })),
                        disabled,
                    },
                    selectedDistributionList: {
                        ...form[NewActivitySectionType.DISTRIBUTION].selectedDistributionList,
                        disabled,
                    },
                    listName: {
                        ...form[NewActivitySectionType.DISTRIBUTION].listName,
                        disabled,
                    },
                },
                NewActivitySectionType.DISTRIBUTION,
                ActivitySection.NEWS_ACTIVITY
            )
            setForm(
                {
                    badge: {
                        ...form[NewActivitySectionType.POINTS_ASSIGNMENT].badge,
                        value: {
                            id: projectDetails.badge?._id,
                            points: projectDetails.badge?.points,
                        },
                    },
                    points: {
                        ...form[NewActivitySectionType.POINTS_ASSIGNMENT].badge,
                        value: projectDetails.badge?.activityPoints,
                    },
                },
                NewActivitySectionType.POINTS_ASSIGNMENT,
                ActivitySection.NEWS_ACTIVITY
            )
            setSmartFilter(projectDetails?.smartFilter)
            setForm(
                {
                    startDate: {
                        ...form[NewActivitySectionType.SCHEDULING].startDate,
                        value:
                            !isClone && projectDetails.startDate > 0
                                ? new Date(projectDetails.startDate)
                                : null,
                        disabled,
                    },
                    endDate: {
                        ...form[NewActivitySectionType.SCHEDULING].endDate,
                        value:
                            !isClone && projectDetails.endDate > 0
                                ? new Date(projectDetails.endDate)
                                : null,
                        disabled,
                    },
                    projectVisibility: {
                        ...form[NewActivitySectionType.SCHEDULING].projectVisibility,
                        value: projectDetails.visibility,
                        disabled,
                    },
                    daysBefore: {
                        ...form[NewActivitySectionType.SCHEDULING].daysBefore,
                        value: getDateDiff(projectDetails.visibilityDate, projectDetails.startDate),
                        disabled,
                    },
                    specificDate: {
                        ...form[NewActivitySectionType.SCHEDULING].specificDate,
                        value:
                            !isClone && projectDetails.visibility === 'specificDate'
                                ? new Date(projectDetails.visibilityDate)
                                : null,
                        disabled,
                    },
                    priority: {
                        ...form[NewActivitySectionType.SCHEDULING].priority,
                        value: projectDetails.priority,
                        disabled,
                    },
                    autoClose: {
                        ...form[NewActivitySectionType.SCHEDULING].autoClose,
                        value: projectDetails.autoclose,
                        disabled,
                    },
                    autoCloseDays: {
                        ...form[NewActivitySectionType.SCHEDULING].autoCloseDays,
                        value: projectDetails.autocloseDate
                            ? getDateDiff(projectDetails.endDate, projectDetails.autocloseDate)
                            : null,
                        disabled,
                    },
                    calendarVisibility: {
                        ...form[NewActivitySectionType.SCHEDULING].calendarVisibility,
                        value: projectDetails.visibilityCalendar,
                        disabled,
                    },
                },
                NewActivitySectionType.SCHEDULING,
                ActivitySection.NEWS_ACTIVITY
            )
            setForm(
                {
                    reasonWhy: { value: projectDetails.reasonChoice },
                    editingReason: { value: projectDetails.reasonChange },
                    messageForStores: { value: projectDetails.messageStores },
                },
                NewActivitySectionType.EDITING_REASON,
                ActivitySection.NEWS_ACTIVITY
            )

            setReasonWhy(projectDetails.reasonChoice)
            setEditingReason(projectDetails.reasonChange)
            setMessageForStore(projectDetails.messageStores)
        }
    }, [projectDetails])

    useEffect(() => {
        const isDone =
            Object.values(form.mainInfo).filter(
                (field: FormField<any>) => field.mandatory && !field.value
            ).length === 0
        setActivitySectionStatus(ActivitySection.NEWS_ACTIVITY, NewActivitySectionType.MAIN_INFO, {
            isDone,
        })
    }, [form.mainInfo])

    useEffect(() => {
        setForm(
            {
                reasonWhy: {
                    value: reasonWhy?.length > 0 ? reasonWhy : projectDetails?.reasonChoice,
                },
                editingReason: {
                    value: editingReason?.length > 0 ? editingReason : projectDetails?.reasonChange,
                },
                messageForStores: {
                    value:
                        messageForStores?.length > 0
                            ? messageForStores
                            : projectDetails?.messageStores,
                },
            },
            NewActivitySectionType.EDITING_REASON,
            ActivitySection.NEWS_ACTIVITY
        )

        let isDone = false

        if (editingReason?.length > 0 && reasonWhy?.length > 0) {
            isDone = true
        }

        setActivitySectionStatus(
            ActivitySection.NEWS_ACTIVITY,
            NewActivitySectionType.EDITING_REASON,
            { isDone }
        )
    }, [reasonWhy, editingReason, messageForStores])

    useEffect(() => {
        const badgePoints =
            form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.points ||
            Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value)
        setActivitySectionStatus(
            ActivitySection.NEWS_ACTIVITY,
            NewActivitySectionType.POINTS_ASSIGNMENT,
            {
                isDone:
                    !!form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) > 0 &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) <=
                        badgePoints,
            }
        )
    }, [form[NewActivitySectionType.POINTS_ASSIGNMENT]])

    return (
        <div className={componentClass}>
            <SectionContainer>
                {step === NewActivitySectionType.EDITING_REASON &&
                    projectDetails?.status !== 'draft' &&
                    projectDetails?.status !== 'rejected' && (
                        <SectionBox
                            title={intl.formatMessage({
                                id: 'modals.new.activity.task.section.editing.reason',
                                defaultMessage: 'Editing Reason',
                            })}>
                            <EditingReason
                                reasonWhy={reasonWhy}
                                editingReason={editingReason}
                                messageForStores={messageForStores}
                                onReasonWhy={setReasonWhy}
                                onEditingReason={setEditingReason}
                                onMessage={setMessageForStore}
                            />
                        </SectionBox>
                    )}
                {step === NewActivitySectionType.NEWS_TYPE && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.news.section.news.type',
                            defaultMessage: 'News Type',
                        })}>
                        <NewsType
                            form={form[NewActivitySectionType.NEWS_TYPE]}
                            onSetForm={(form) => onNewsTypeChange(form)}
                            typeList={
                                activityTypeList?.find((a) => a.key === SmartlyActionItems.NEWS)
                                    ?.subTypes
                            }
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.MAIN_INFO && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info',
                            defaultMessage: 'Main Information',
                        })}>
                        <NewsMainInfo
                            form={form[NewActivitySectionType.MAIN_INFO]}
                            onSetForm={(form) => onMainInfoChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.MAIN_INFO)}
                            isDone={sectionMap[NewActivitySectionType.MAIN_INFO].isDone}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.DISTRIBUTION && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.distribution',
                            defaultMessage: 'Distribution',
                        })}>
                        <Distribution
                            tableConfigId={`new_activity_news`}
                            form={form.distribution}
                            onSetForm={(form) => onDistributionChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.DISTRIBUTION)}
                            storesToImport={storesToImport}
                            openDialogUploadList={openDialogUploadList}
                            openDialogExportTemplate={openDialogExportTemplate}
                            smartFilter={smartFilter}
                            setSmartFilter={setSmartFilter}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.POINTS_ASSIGNMENT && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.points.assignment',
                            defaultMessage: 'Points Assignment',
                        })}>
                        <PointsAssignments
                            form={form.pointsAssignment}
                            storeIds={
                                form[NewActivitySectionType.DISTRIBUTION].selectedStoreList.value
                            }
                            onSetForm={onPointsAssignment}
                            isDone={sectionMap[NewActivitySectionType.POINTS_ASSIGNMENT].isDone}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.SCHEDULING && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.scheduling',
                            defaultMessage: 'Scheduling',
                        })}>
                        <Scheduling
                            form={form[NewActivitySectionType.SCHEDULING]}
                            onSetForm={(form) => onSchedulingChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.SCHEDULING)}
                            onClear={() =>
                                onSchedulingChange({
                                    ...newsForm[NewActivitySectionType.SCHEDULING],
                                })
                            }
                            isDone={sectionMap[NewActivitySectionType.SCHEDULING].isDone}
                        />
                    </SectionBox>
                )}
            </SectionContainer>
            <DialogDuplicate
                dialogVisible={showDuplicateDialog}
                onSave={onDuplicateConfirm}
                onHide={() => setShowDuplicateDialog(false)}
            />
            <DialogHistoryChange
                dialogVisible={showHistoryChangeDialog}
                onHide={() => setShowHistoryChangeDialog(false)}
                changeFields={changeFields}
                timezone={projectDetails?.timeZone}
            />
            {isResetMandatory && (
                <DialogResetStore
                    dialogVisible={isResetMandatory}
                    onHide={() => setResetMandatory(false)}
                    onSave={(confirm) => handlerEditProject(confirm)}
                    changeFields={changeFields}
                    storesList={getEditSelectedStoreList(
                        form.distribution.selectedStoreList.value,
                        projectDetails
                    )}
                    timezone={projectDetails?.timeZone}
                />
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    sectionMap: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].newsActivity.sectionMap,
    form: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE][ActivitySection.NEWS_ACTIVITY].form,
    projectVisibilityOptions:
        state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].projectVisibilityOptions,
    typeList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].newsActivity.typeList,
    changeFields: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].changeFields,
    isClone: state.layoutReducer.modals.props?.isClone,
    isEdit: state.layoutReducer.modals.props?.isEdit,
    storeIdList: state.layoutReducer.modals.props?.storeIds,
    activityTypeList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].activityTypeList,
    isResetMandatory: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].isResetMandatory,
    storesList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].storesList,
    smartFilter: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].smartFilter,
    projectDetails: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].projectDetails,
})

const mapDispatchToProps = (dispatch: any) => ({
    setActivitySectionStatus: (
        activityKey: string,
        sectionKey: NewActivitySectionType,
        section: Partial<ActivityStep>
    ) => dispatch(setActivitySectionStatus(activityKey, sectionKey, section)),
    setActivityTypeList: (activityKey: string, typeList: any[]) =>
        dispatch(setActivityTypeList(activityKey, typeList)),
    setForm: (form: NewsForm, section: NewActivitySectionType, activityName: ActivitySection) =>
        dispatch(setNewActivityForm<NewsForm>(form, section, activityName)),
    setCtaTemplate: (template) => dispatch(setCtaTemplate(template)),
    createProject: (
        form: ProjectApiCreateActivityBody,
        successMessage: string,
        errorMessage: string
    ) => dispatch(createProject(form, successMessage, errorMessage)),
    cancelProject: (projectId: string, successMessage: string) =>
        dispatch(cancelProject(projectId, successMessage)),

    historyChange: (
        newProject: any,
        invokeEditApi?: boolean,
        reasonChoice?: string[],
        reasonChange?: string,
        messageStores?: string,
        successMessage?: string,
        statusAction?: string
    ) =>
        dispatch(
            historyChange(
                newProject,
                invokeEditApi,
                reasonChoice,
                reasonChange,
                messageStores,
                successMessage,
                statusAction
            )
        ),
    editProject: (
        newProject: any,
        reasonChoice: string[],
        reasonChange: string,
        messageStores: string,
        successMessage: string,
        statusAction?: string
    ) =>
        dispatch(
            editProject(
                newProject,
                reasonChoice,
                reasonChange,
                messageStores,
                successMessage,
                statusAction
            )
        ),
    setResetMandatory: (value: boolean) => dispatch(setResetMandatory(value)),
    saveAsToBeReleased: (projectId: string, successMessage: string, storeIdList) =>
        dispatch(saveAsToBeReleased(projectId, successMessage, storeIdList)),
    setSmartFilter: (value: any) => dispatch(setSmartFilterActivity(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewActivityNews)
